import React from 'react'
import { Spinner, Flex, Text } from '@chilipiper/design-system'
import { useTranslations } from '../../../context/TranslationContext'
import { StyledBookMeetingContainer } from './styles'
import { ScheduleHeader } from './components/ScheduleHeader'

export const BookingFlowBlockLoading = ({
  state,
}: {
  state: 'scheduled' | 'scheduling' | undefined
}) => {
  const [bookingLoader] = useTranslations(['bookingLoader'])
  return (
    <StyledBookMeetingContainer w='100%' flexDirection='column' borderRadius={8}>
      {state && <ScheduleHeader state={state} />}
      <Flex p={7} my={1} justifyContent='center' alignItems='center'>
        <Spinner />
        <Text color='fg/moderate' ml={2} fontWeight={500}>
          {bookingLoader ?? 'Booking meeting'}
        </Text>
      </Flex>
    </StyledBookMeetingContainer>
  )
}
